// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-dots-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.loading-dot {
    width: 8px;
    height: 8px;
    background-color: #16579c;
    border-radius: 50%;
    animation: bounce 1.2s infinite ease-in-out both;
}

.loading-dot:nth-child(1) {
    animation-delay: -0.32s;
}

.loading-dot:nth-child(2) {
    animation-delay: -0.16s;
}

@keyframes bounce {
    0%, 80%, 100% {
        transform: scale(0);
    }
    40% {
        transform: scale(1);
    }
}

  `, "",{"version":3,"sources":["webpack://./src/LoadingDots.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".loading-dots-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n}\n\n.loading-dot {\n    width: 8px;\n    height: 8px;\n    background-color: #16579c;\n    border-radius: 50%;\n    animation: bounce 1.2s infinite ease-in-out both;\n}\n\n.loading-dot:nth-child(1) {\n    animation-delay: -0.32s;\n}\n\n.loading-dot:nth-child(2) {\n    animation-delay: -0.16s;\n}\n\n@keyframes bounce {\n    0%, 80%, 100% {\n        transform: scale(0);\n    }\n    40% {\n        transform: scale(1);\n    }\n}\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
